import type { ReactNode } from 'react';

export const symbol_line_end_square: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M500-320h320v-320H500v320Zm-30 60q-12.75 0-21.37-8.63Q440-277.25 440-290v-160H110q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-510 110-510h330v-160q0-12.75 8.63-21.38Q457.25-700 470-700h380q12.75 0 21.38 8.62Q880-682.75 880-670v380q0 12.75-8.62 21.37Q862.75-260 850-260H470Zm190-220Z"
		/>
	</svg>
);
